import React, { useEffect, useState } from 'react';
import createConfigurableGridViewModel, {
  ViewModelType
} from '../Components/ConfigurableGrid/configurable-grid-view-model';
import ConfigurableGridView from '../Components/ConfigurableGrid/ConfigurableGridView';
import { useDashboard } from './DashboardContext';

const DashboardView = () => {
  const [queryString] = useDashboard();
  const [inited, setInited] = useState(false);

  const [viewModel, setViewModel] = useState<ViewModelType | null>();

  useEffect(() => {
    setInited(false);
    const initData = async () => {
      const vm = createConfigurableGridViewModel({
        id: queryString.get('meaId') || '',
        viewDefinitionId: queryString.get('viewdefinitionId') || ''
      });
      setViewModel(vm);
      setInited(true);
    };
    initData();
  }, [queryString]);

  return inited && viewModel ? (
    <div data-testid="dashboard-main">
      <ConfigurableGridView viewModel={viewModel} />
    </div>
  ) : null;
};

export default DashboardView;
